<template>
  <div class="zj-moble-app-page">
    <mt-header class="zj-mt-header" fixed="true" title="大孚商户平台">
    </mt-header>
    <div class="zj-mt-content">
       <div class="img_box">
          <img class="log_img"  src="../../images/header-logo.png"  />
      </div>
      <div class="login_box">
        <div class="login_box_item">
          <mt-field label="登录名" placeholder="请输入登录名" v-model="loginname"></mt-field>
        </div>
        <div class="login_box_item">
          <mt-field label="密 码" placeholder="请输入密码" type="password" v-model="loginpwd"></mt-field>
       </div>
       <div class="login_box_item">
          <mt-button type="primary" size="large" @click="onSubmit">登录</mt-button>
       </div>
      </div>
    </div>
    <div class="zj-mt-footer">
        
     </div>
  </div>
</template>

<script>


import utils from '../../../../../../utils';
import WebApis from "../../apis";
import { Toast } from 'mint-ui';
import Vue from 'vue'
import { Field } from 'mint-ui';
Vue.component(Field.name, Field);


export default {
  name: "Login",
  controller: "UI",
  action: "Login",
  data() {
      return {
        loginname:"",
        loginpwd:"",
        vtoken: utils.uuid(),
        vcode: '',
        captchaTimestamp: (new Date()).getTime(),
        is_login: false
      }
     
  },
  created() {
   
  },
  methods: {
    // 登录
    login() {
      this.is_login = true
      let loginInfo = {
        LoginName: this.loginname,
        LoginPwd: this.loginpwd,
        vtoken: this.vtoken,
        vcode: this.vcode
      }
      new WebApis.UserApi().GetUserByLoginInfo(loginInfo)
      .then(r => {
        r = r.data.Data;
        this.onLogin(r)
        this.is_login = false
      }).catch((e) => {
        console.log(e)
        Toast(e.RspMsg ? e.RspMsg : '服务异常，请联系管理员！');
        this.is_login = false
      })
    },
    // 登录成功
    // onLogin(user, loginInfo) {
    //   this.user.setUser(user, loginInfo.LoginPwd);
    //   this.$emit('login', user)
    // },
    onLogin(user){
      localStorage.setItem('loginuser', JSON.stringify(user));
      this.$router.push("/m/payment/orderList");
    },
    onSubmit() {
      this.login()
    },
  },
  computed: {
   
  }
};

</script>
<style  scoped>
.login_box{
  background-color: #f8f8f8;
  padding: 0.1rem;
  margin: 0.1rem;
  margin-top: 0.4rem;
}

.img_box{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
}

.log_img{
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
}

.login_box_item
{
    padding-top: 0.1rem;
}

.mint-field
{
    margin-top: 0.1rem;
    margin-bottom: 0.1rem;
    margin-left: 0.1rem;
    margin-right: 0.1rem;
    height: 1rem;
}

.mint-button
{
    height: 0.8rem;
}

</style>